import { AlertType, TriggerSettings, TriggerType } from "api/model/alerts/alert-types";
import { AlertTypeSettings, DatasetsWarnSettings, ServerMessageSettings, TextAlertSettings } from "./types";

export const getDefaultSettingsForType = (type: TriggerType): TriggerSettings => {
  switch (type) {
    case "DATASET_VALUE_CHANGED":
      return { triggerType: "DATASET_VALUE_CHANGED", datasetId: "000:REMOTE_CATEGORIZED_DATASET" };
    case "DATASET_VALUE_EQUALS":
      return {
        triggerType: "DATASET_VALUE_EQUALS",
        datasetId: "000:REMOTE_CATEGORIZED_DATASET",
        value: 0,
        tolerance: 0.0001,
      };
    case "DATASET_VALUE_IN_RANGE":
      return {
        triggerType: "DATASET_VALUE_IN_RANGE",
        datasetId: "000:REMOTE_CATEGORIZED_DATASET",
        min: 0,
        max: 100,
        inclusive: true,
      };
    case "PRODUCT_TEMPLATE_VALUE_CHANGED":
      return { triggerType: "PRODUCT_TEMPLATE_VALUE_CHANGED", productTemplateId: "", fieldName: "" };
    default:
      return { triggerType: "DATASET_VALUE_CHANGED", datasetId: "000:REMOTE_CATEGORIZED_DATASET" };
  }
};

// Helper function to get default settings for each alert type
export const getDefaultTypeSettings = (alertType: AlertType): AlertTypeSettings => {
  switch (alertType) {
    case "SERVER_MESSAGE":
      return {
        title: "",
        message: "",
        shortMessage: "",
        timeoutMinutes: 60,
      } as ServerMessageSettings;
    case "DATASETS_WARN":
      return {
        datasetIds: [],
        message: "",
        shortMessage: "",
        timeoutMinutes: 60,
      } as DatasetsWarnSettings;
    case "TEXT":
      return {
        htmlContent: "",
        message: "",
        shortMessage: "",
        timeoutMinutes: 60,
      } as TextAlertSettings;
    default:
      return {
        shortMessage: "",
        timeoutMinutes: 60,
      } as ServerMessageSettings;
  }
};

// Helper function to format trigger settings in a human-readable way
export const formatTriggerSettings = (triggerType: TriggerType, settings: TriggerSettings): string => {
  switch (triggerType) {
    case "DATASET_VALUE_CHANGED": {
      const s = settings as { datasetId: string };
      return `Dataset: ${s.datasetId}`;
    }
    case "DATASET_VALUE_EQUALS": {
      const s = settings as { datasetId: string; value: number; tolerance?: number };
      const tolerance = s.tolerance ? ` ±${s.tolerance}` : "";
      return `Dataset: ${s.datasetId}, Value: ${s.value}${tolerance}`;
    }
    case "DATASET_VALUE_IN_RANGE": {
      const s = settings as { datasetId: string; min: number; max: number; inclusive?: boolean };
      const brackets = s.inclusive ? "[]" : "()";
      return `Dataset: ${s.datasetId}, Range: ${brackets[0]}${s.min}, ${s.max}${brackets[1]}`;
    }
    case "PRODUCT_TEMPLATE_VALUE_CHANGED": {
      const s = settings as { productTemplateId: string; fieldName: string };
      return `Template: ${s.productTemplateId}, Field: ${s.fieldName}`;
    }
    default:
      return JSON.stringify(settings);
  }
};
